function Footer() {
  return (
    <footer className="site-footer">
      <div><span className="footer-mark">AM /</span><span>ARMAND MAZALAN</span></div>
      <span>BUILD WITH INTENT / 2026</span>
      <a href="#top" data-testid="footer-back-to-top-link">Back to top ↑</a>
    </footer>
  );
}

export default Footer;
